import React, {Suspense} from "react";
import {routesRendered} from "routes";

export default function _app() {
  return <Suspense fallback={<p />}>{routesRendered}</Suspense>;
}
